
export enum CulturalLeadershipConnectionStatusFilter {
    InactiveOnly = "InactiveOnly",
    ActiveOnly = "ActiveOnly",
    All = "All",
}
